var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "level" },
            [
              _c(
                "Header",
                _vm._b(
                  { staticClass: "level-left" },
                  "Header",
                  _vm.$route.meta,
                  false
                )
              ),
              _c(
                "b-button",
                {
                  staticClass: "left-right",
                  attrs: {
                    type: "is-success",
                    "icon-left": "plus",
                    disabled:
                      _vm.selectedPlant === null || _vm.employees.length === 0,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showCreateForm()
                    },
                  },
                },
                [_vm._v(" Create New Activity ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c(
                  "b-field",
                  { attrs: { grouped: "" } },
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "Start Date" } },
                      [
                        _c("b-datepicker", {
                          attrs: {
                            name: "startdate",
                            "first-day-of-week": 1,
                            locale: "en-CA",
                            icon: "calendar-alt",
                            placeholder: "Start date",
                          },
                          model: {
                            value: _vm.start,
                            callback: function ($$v) {
                              _vm.start = $$v
                            },
                            expression: "start",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: "End Date" } },
                      [
                        _c("b-datepicker", {
                          attrs: {
                            name: "enddate",
                            "first-day-of-week": 1,
                            locale: "en-CA",
                            icon: "calendar-alt",
                            placeholder: "End date",
                          },
                          model: {
                            value: _vm.end,
                            callback: function ($$v) {
                              _vm.end = $$v
                            },
                            expression: "end",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm.user.group.plants && _vm.user.group.plants.length != 0
                      ? _c(
                          "b-field",
                          { attrs: { label: "Plant" } },
                          [
                            _c(
                              "b-select",
                              {
                                attrs: { icon: "industry", expanded: "" },
                                model: {
                                  value: _vm.selectedPlant,
                                  callback: function ($$v) {
                                    _vm.selectedPlant = $$v
                                  },
                                  expression: "selectedPlant",
                                },
                              },
                              _vm._l(_vm.user.group.plants, function (plant) {
                                return _c(
                                  "option",
                                  { key: plant.id, domProps: { value: plant } },
                                  [_vm._v(" " + _vm._s(plant.name) + " ")]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        )
                      : _c(
                          "b-field",
                          { attrs: { label: "Plant" } },
                          [
                            _c("multiselect", {
                              staticStyle: { "min-width": "400px" },
                              attrs: {
                                options: _vm.plants,
                                multiple: false,
                                "close-on-select": true,
                                placeholder: "Pick plant",
                                "custom-label": (obj) =>
                                  obj.id + " - " + obj.name,
                                "track-by": "name",
                              },
                              model: {
                                value: _vm.selectedPlant,
                                callback: function ($$v) {
                                  _vm.selectedPlant = $$v
                                },
                                expression: "selectedPlant",
                              },
                            }),
                          ],
                          1
                        ),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "left-right",
                        attrs: {
                          type: "is-warning",
                          "icon-left": "arrows-rotate",
                          disabled: _vm.isLoading || _vm.selectedPlant === null,
                        },
                        on: {
                          click: () => {
                            _vm.resetData()
                            _vm.getData()
                          },
                        },
                      },
                      [_vm._v(" Load ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._l(_vm.schedules, function (schedule, index) {
            return _c(
              "div",
              {
                key: schedule.date,
                staticClass: "card pl-2 py-1",
                style: {
                  "margin-top": "2rem",
                  "padding-right": "0.75rem",
                  border: "2px solid transparent",
                  "border-image-slice": "1",
                  "border-image":
                    "linear-gradient(to left, rgb(125, 125, 125), rgb(225, 225, 225)) 3",
                },
              },
              [
                _c(
                  "div",
                  { style: { "text-transform": "capitalize" } },
                  [
                    _c("b-button", {
                      staticClass: "left-right mr-2",
                      style: {
                        display: "block",
                        position: "absolute",
                        right: "0",
                        "margin-top": "-10px",
                      },
                      attrs: {
                        type: "is-ghost",
                        "icon-left": "edit",
                        disabled: _vm.isLoading,
                      },
                      on: {
                        click: () => {
                          _vm.showEditForm(schedule)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { style: { "text-transform": "capitalize" } }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        new Date(
                          new Date(schedule.date.split("Z")[0])
                            .toISOString()
                            .split("T")[0] + "T00:00:00"
                        ).toLocaleDateString("en-EN", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "div",
                  {
                    style: {
                      border: "1px rgb(190, 190, 190) solid",
                      "background-color": "rgba(190, 230, 250, 1)",
                      display: "flex",
                      "justify-content": "space-around",
                    },
                  },
                  [
                    _c("div", { staticClass: "shift-activity-name" }, [
                      _vm._v(" AM "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Absent "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Manual "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Machine "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Repair "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Doors "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Forklift "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Special "),
                    ]),
                    _c("div", { staticClass: "shift-activity-comment" }, [
                      _vm._v(" Comment "),
                    ]),
                  ]
                ),
                _vm._l(schedule.AM, function (employee) {
                  return _c(
                    "div",
                    {
                      key: "AM" + employee.name + index,
                      style: {
                        border: "1px rgb(190, 190, 190) solid",
                        display: "flex",
                        "justify-content": "space-around",
                      },
                    },
                    [
                      _c("div", { staticClass: "shift-activity-name" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              employee.name +
                                (employee.surname && employee.surname.length > 0
                                  ? " " + employee.surname
                                  : "")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.absent) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.washing) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.machine) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.repair) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.doors) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.forklift) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.special) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity-comment" }, [
                        _vm._v(" " + _vm._s(employee.comment) + " "),
                      ]),
                    ]
                  )
                }),
                schedule.AM && schedule.AM.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          "border-top": "2px rgb(150, 150, 150) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.declared_hours"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "washing"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.washing),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "washing"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "machineWash"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.machine),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "machineWash"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "repair"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.repair),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "repair"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "repair__door"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.doors),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "repair__door"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amForklift ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.forklift),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [_vm._v(" " + _vm._s(schedule.amForklift) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "special"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.special),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "special"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                schedule.AM && schedule.AM.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.assigned_hours"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + (element.absent != "no"),
                                  0
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "washing"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.washing),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.AM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.washing),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "machineWash"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.machine),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.AM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.machine),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "repair"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.repair),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.AM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.repair),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "repair__door"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.doors),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.AM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.doors),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amForklift ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.forklift),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.AM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.forklift),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "special"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.AM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.special),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.AM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.special),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                schedule.AM && schedule.AM.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.treated_material"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "washing"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "machineWash"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "repair"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "repair__door"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.amMovements
                                  .filter((x) => {
                                    return (
                                      x.operation.split("__")[0] === "forklift"
                                    )
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.amMovements
                                  .filter((x) => {
                                    return x.operation === "special"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                schedule.AM && schedule.AM.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.efficiency"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "washing"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.amMovements
                                      .filter((x) => {
                                        return x.operation === "washing"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "machineWash"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.amMovements
                                      .filter((x) => {
                                        return x.operation === "machineWash"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "repair"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.amMovements
                                      .filter((x) => {
                                        return x.operation === "repair"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "repair__door"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.amMovements
                                      .filter((x) => {
                                        return x.operation === "repair__door"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.amMovements
                                    .filter((x) => {
                                      return x.operation === "special"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.amMovements
                                      .filter((x) => {
                                        return x.operation === "special"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    style: {
                      border: "1px rgb(190, 190, 190) solid",
                      "background-color": "rgba(150, 190, 210, 1)",
                      display: "flex",
                      "justify-content": "space-around",
                    },
                  },
                  [
                    _c("div", { staticClass: "shift-activity-name" }, [
                      _vm._v(" PM "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Absent "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Manual "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Machine "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Repair "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Doors "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Forklift "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Special "),
                    ]),
                    _c("div", { staticClass: "shift-activity-comment" }, [
                      _vm._v(" Comment "),
                    ]),
                  ]
                ),
                _vm._l(schedule.PM, function (employee) {
                  return _c(
                    "div",
                    {
                      key: "PM" + employee.name + index,
                      style: {
                        border: "1px rgb(190, 190, 190) solid",
                        display: "flex",
                        "justify-content": "space-around",
                      },
                    },
                    [
                      _c("div", { staticClass: "shift-activity-name" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              employee.name +
                                (employee.surname && employee.surname.length > 0
                                  ? " " + employee.surname
                                  : "")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.absent) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.washing) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.machine) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.repair) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.doors) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.forklift) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.special) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity-comment" }, [
                        _vm._v(" " + _vm._s(employee.comment) + " "),
                      ]),
                    ]
                  )
                }),
                schedule.PM && schedule.PM.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          "border-top": "2px rgb(150, 150, 150) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.declared_hours"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "washing"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.washing),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "washing"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "machineWash"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.machine),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "machineWash"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "repair"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.repair),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "repair"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "repair__door"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.doors),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "repair__door"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmForklift ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.forklift),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [_vm._v(" " + _vm._s(schedule.pmForklift) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "special"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.special),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "special"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                schedule.PM && schedule.PM.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.assigned_hours"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + (element.absent != "no"),
                                  0
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "washing"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.washing),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.PM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.washing),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "machineWash"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.machine),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.PM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.machine),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "repair"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.repair),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.PM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.repair),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "repair__door"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.doors),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.PM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.doors),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmForklift ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.forklift),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.PM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.forklift),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "special"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.PM.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.special),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.PM.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.special),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                schedule.PM && schedule.PM.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.treated_material"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "washing"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "machineWash"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "repair"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "repair__door"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.pmMovements
                                  .filter((x) => {
                                    return (
                                      x.operation.split("__")[0] === "forklift"
                                    )
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.pmMovements
                                  .filter((x) => {
                                    return x.operation === "special"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                schedule.PM && schedule.PM.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.efficiency"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "washing"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.pmMovements
                                      .filter((x) => {
                                        return x.operation === "washing"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "machineWash"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.pmMovements
                                      .filter((x) => {
                                        return x.operation === "machineWash"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "repair"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.pmMovements
                                      .filter((x) => {
                                        return x.operation === "repair"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "repair__door"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.pmMovements
                                      .filter((x) => {
                                        return x.operation === "repair__door"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.pmMovements
                                    .filter((x) => {
                                      return x.operation === "special"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.pmMovements
                                      .filter((x) => {
                                        return x.operation === "special"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    style: {
                      border: "1px rgb(190, 190, 190) solid",
                      "background-color": "rgba(110, 150, 170, 1)",
                      display: "flex",
                      "justify-content": "space-around",
                    },
                  },
                  [
                    _c("div", { staticClass: "shift-activity-name" }, [
                      _vm._v(" Night "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Absent "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Manual "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Machine "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Repair "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Doors "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Forklift "),
                    ]),
                    _c("div", { staticClass: "shift-activity" }, [
                      _vm._v(" Special "),
                    ]),
                    _c("div", { staticClass: "shift-activity-comment" }, [
                      _vm._v(" Comment "),
                    ]),
                  ]
                ),
                _vm._l(schedule.Night, function (employee) {
                  return _c(
                    "div",
                    {
                      key: "Night" + employee.name + index,
                      style: {
                        border: "1px rgb(190, 190, 190) solid",
                        display: "flex",
                        "justify-content": "space-around",
                      },
                    },
                    [
                      _c("div", { staticClass: "shift-activity-name" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              employee.name +
                                (employee.surname && employee.surname.length > 0
                                  ? " " + employee.surname
                                  : "")
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.absent) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.washing) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.machine) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.repair) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.doors) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.forklift) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity" }, [
                        _vm._v(" " + _vm._s(employee.special) + " "),
                      ]),
                      _c("div", { staticClass: "shift-activity-comment" }, [
                        _vm._v(" " + _vm._s(employee.comment) + " "),
                      ]),
                    ]
                  )
                }),
                schedule.Night && schedule.Night.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          "border-top": "2px rgb(150, 150, 150) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.declared_hours"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "washing"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.washing),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "washing"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "machineWash"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.machine),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "machineWash"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "repair"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.repair),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "repair"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "repair__door"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.doors),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "repair__door"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightForklift ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.forklift),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [_vm._v(" " + _vm._s(schedule.nightForklift) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "special"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.special),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "special"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.hours),
                                      0
                                    )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                schedule.Night && schedule.Night.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.assigned_hours"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + (element.absent != "no"),
                                  0
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "washing"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.washing),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.Night.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.washing),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "machineWash"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.machine),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.Night.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.machine),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "repair"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.repair),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.Night.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.repair),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "repair__door"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.doors),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.Night.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.doors),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightForklift ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.forklift),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.Night.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.forklift),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "shift-activity",
                            style: {
                              color:
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "special"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.hours),
                                    0
                                  ) ===
                                schedule.Night.reduce(
                                  (sum, element) =>
                                    sum + parseFloat(element.special),
                                  0
                                )
                                  ? ""
                                  : "red",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  schedule.Night.reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.special),
                                    0
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                schedule.Night && schedule.Night.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.treated_material"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "washing"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "machineWash"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "repair"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "repair__door"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.nightMovements
                                  .filter((x) => {
                                    return (
                                      x.operation.split("__")[0] === "forklift"
                                    )
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                schedule.nightMovements
                                  .filter((x) => {
                                    return x.operation === "special"
                                  })
                                  .reduce(
                                    (sum, element) =>
                                      sum + parseFloat(element.num_crates),
                                    0
                                  )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
                schedule.Night && schedule.Night.length > 0
                  ? _c(
                      "div",
                      {
                        style: {
                          border: "1px rgb(190, 190, 190) solid",
                          display: "flex",
                          "justify-content": "space-around",
                        },
                      },
                      [
                        _c("div", { staticClass: "shift-activity-name" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "pages.production_data.employee_schedule.efficiency"
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "washing"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.nightMovements
                                      .filter((x) => {
                                        return x.operation === "washing"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "machineWash"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.nightMovements
                                      .filter((x) => {
                                        return x.operation === "machineWash"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "repair"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.nightMovements
                                      .filter((x) => {
                                        return x.operation === "repair"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "repair__door"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.nightMovements
                                      .filter((x) => {
                                        return x.operation === "repair__door"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                        _c("div", { staticClass: "shift-activity" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                (
                                  schedule.nightMovements
                                    .filter((x) => {
                                      return x.operation === "special"
                                    })
                                    .reduce(
                                      (sum, element) =>
                                        sum + parseFloat(element.num_crates),
                                      0
                                    ) /
                                    schedule.nightMovements
                                      .filter((x) => {
                                        return x.operation === "special"
                                      })
                                      .reduce(
                                        (sum, element) =>
                                          sum + parseFloat(element.hours),
                                        0
                                      ) || 0
                                ).toFixed(1)
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "shift-activity-comment" }, [
                          _vm._v(" " + _vm._s("") + " "),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          key: _vm.modalKey,
          attrs: {
            "can-cancel": ["escape", "x"],
            active: _vm.isCreatingSchedule,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isCreatingSchedule = $event
            },
          },
        },
        [
          _vm.isCreatingSchedule
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitSchedule.apply(null, arguments)
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Create or Edit Schedule "),
                          _vm.selectedPlant
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.selectedPlant.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Date" } },
                                [
                                  _c("b-datepicker", {
                                    attrs: {
                                      "first-day-of-week": 1,
                                      name: "newdate",
                                      locale: "en-CA",
                                      icon: "calendar-alt",
                                    },
                                    on: { input: _vm.updateEmployeeList },
                                    model: {
                                      value: _vm.newSchedule.date,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.newSchedule, "date", $$v)
                                      },
                                      expression: "newSchedule.date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(_vm.createEmployees, function (employee) {
                            return _c(
                              "div",
                              {
                                key: employee.id + "new",
                                staticStyle: { width: "10%" },
                              },
                              [
                                _c(
                                  "b-field",
                                  { attrs: { grouped: "" } },
                                  [
                                    _c(
                                      "b-field",
                                      {
                                        staticStyle: { "margin-top": "0.7em" },
                                      },
                                      [
                                        _c("multiselect", {
                                          attrs: {
                                            options: ["AM", "PM", "Night"],
                                            multiple: true,
                                            searchable: false,
                                            "show-labels": false,
                                            "close-on-select": false,
                                          },
                                          model: {
                                            value:
                                              _vm.newSchedule.shift[
                                                employee.id
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newSchedule.shift,
                                                employee.id,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "newSchedule.shift[employee.id]",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-field",
                                      {
                                        staticStyle: {
                                          "align-content": "center",
                                          "margin-top": "0.5em",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              employee.name +
                                                (employee.surname &&
                                                employee.surname.length > 0
                                                  ? " " + employee.surname
                                                  : "")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _vm.newSchedule.shift[employee.id].length <=
                                    0
                                      ? _c(
                                          "b-field",
                                          { attrs: { grouped: "" } },
                                          [
                                            _c(
                                              "b-checkbox",
                                              {
                                                model: {
                                                  value:
                                                    _vm.newSchedule.deleted[
                                                      employee.id
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.newSchedule.deleted,
                                                      employee.id,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newSchedule.deleted[employee.id]",
                                                },
                                              },
                                              [_vm._v(" No Shift? ")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.newSchedule.shift[employee.id].includes(
                                      "AM"
                                    )
                                      ? _c(
                                          "b-field",
                                          { attrs: { grouped: "" } },
                                          [
                                            _c(
                                              "b-field",
                                              { attrs: { label: "ᅟ" } },
                                              [
                                                _c(
                                                  "b-field",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                      width: "5ch",
                                                    },
                                                  },
                                                  [_vm._v(" AM ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Manual" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.AM
                                                        .washing[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.AM
                                                          .washing,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.AM.washing[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Machine" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.AM
                                                        .machine[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.AM
                                                          .machine,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.AM.machine[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Repair" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.AM.repair[
                                                        employee.id
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.AM
                                                          .repair,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.AM.repair[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Doors" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.AM.doors[
                                                        employee.id
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.AM
                                                          .doors,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.AM.doors[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Forklift" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.AM
                                                        .forklift[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.AM
                                                          .forklift,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.AM.forklift[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Special" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.AM
                                                        .special[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.AM
                                                          .special,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.AM.special[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Comment" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: {
                                                    width: "10em",
                                                  },
                                                  attrs: { type: "text" },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.AM
                                                        .comment[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.AM
                                                          .comment,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.AM.comment[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Absence" } },
                                              [
                                                _c(
                                                  "b-select",
                                                  {
                                                    staticStyle: {
                                                      width: "6em",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newSchedule.AM
                                                          .absence[employee.id],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.newSchedule.AM
                                                            .absence,
                                                          employee.id,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newSchedule.AM.absence[employee.id]",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "no" },
                                                      },
                                                      [_vm._v(" No ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AL" },
                                                      },
                                                      [_vm._v(" Annual Leave ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "ML" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Medical Leave "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AB" },
                                                      },
                                                      [_vm._v(" Absence ")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              {
                                                staticStyle: {
                                                  "align-content": "center",
                                                },
                                                attrs: { label: "ᅟ" },
                                              },
                                              [
                                                _c("b-checkbox", {
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.AM
                                                        .checked[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.AM
                                                          .checked,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.AM.checked[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.newSchedule.shift[employee.id].includes(
                                      "PM"
                                    )
                                      ? _c(
                                          "b-field",
                                          { attrs: { grouped: "" } },
                                          [
                                            _c(
                                              "b-field",
                                              { attrs: { label: "ᅟ" } },
                                              [
                                                _c(
                                                  "b-field",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                      width: "5ch",
                                                    },
                                                  },
                                                  [_vm._v(" PM ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Manual" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.PM
                                                        .washing[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.PM
                                                          .washing,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.PM.washing[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Machine" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.PM
                                                        .machine[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.PM
                                                          .machine,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.PM.machine[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Repair" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.PM.repair[
                                                        employee.id
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.PM
                                                          .repair,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.PM.repair[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Doors" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.PM.doors[
                                                        employee.id
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.PM
                                                          .doors,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.PM.doors[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Forklift" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.PM
                                                        .forklift[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.PM
                                                          .forklift,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.PM.forklift[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Special" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.PM
                                                        .special[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.PM
                                                          .special,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.PM.special[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Comment" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: {
                                                    width: "10em",
                                                  },
                                                  attrs: { type: "text" },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.PM
                                                        .comment[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.PM
                                                          .comment,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.PM.comment[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Absence" } },
                                              [
                                                _c(
                                                  "b-select",
                                                  {
                                                    staticStyle: {
                                                      width: "6em",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newSchedule.PM
                                                          .absence[employee.id],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.newSchedule.PM
                                                            .absence,
                                                          employee.id,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newSchedule.PM.absence[employee.id]",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "no" },
                                                      },
                                                      [_vm._v(" No ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AL" },
                                                      },
                                                      [_vm._v(" Annual Leave ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "ML" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Medical Leave "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AB" },
                                                      },
                                                      [_vm._v(" Absence ")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              {
                                                staticStyle: {
                                                  "align-content": "center",
                                                },
                                                attrs: { label: "ᅟ" },
                                              },
                                              [
                                                _c("b-checkbox", {
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.PM
                                                        .checked[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.PM
                                                          .checked,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.PM.checked[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.newSchedule.shift[employee.id].includes(
                                      "Night"
                                    )
                                      ? _c(
                                          "b-field",
                                          { attrs: { grouped: "" } },
                                          [
                                            _c(
                                              "b-field",
                                              { attrs: { label: "ᅟ" } },
                                              [
                                                _c(
                                                  "b-field",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                      width: "5ch",
                                                    },
                                                  },
                                                  [_vm._v(" Night ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Manual" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.Night
                                                        .washing[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.Night
                                                          .washing,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.Night.washing[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Machine" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.Night
                                                        .machine[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.Night
                                                          .machine,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.Night.machine[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Repair" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.Night
                                                        .repair[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.Night
                                                          .repair,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.Night.repair[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Doors" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.Night
                                                        .doors[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.Night
                                                          .doors,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.Night.doors[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Forklift" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.Night
                                                        .forklift[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.Night
                                                          .forklift,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.Night.forklift[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Special" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.Night
                                                        .special[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.Night
                                                          .special,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.Night.special[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Comment" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: {
                                                    width: "10em",
                                                  },
                                                  attrs: { type: "text" },
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.Night
                                                        .comment[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.Night
                                                          .comment,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.Night.comment[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Absence" } },
                                              [
                                                _c(
                                                  "b-select",
                                                  {
                                                    staticStyle: {
                                                      width: "6em",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newSchedule.Night
                                                          .absence[employee.id],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.newSchedule.Night
                                                            .absence,
                                                          employee.id,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "newSchedule.Night.absence[employee.id]",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "no" },
                                                      },
                                                      [_vm._v(" No ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AL" },
                                                      },
                                                      [_vm._v(" Annual Leave ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "ML" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Medical Leave "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AB" },
                                                      },
                                                      [_vm._v(" Absence ")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              {
                                                staticStyle: {
                                                  "align-content": "center",
                                                },
                                                attrs: { label: "ᅟ" },
                                              },
                                              [
                                                _c("b-checkbox", {
                                                  model: {
                                                    value:
                                                      _vm.newSchedule.Night
                                                        .checked[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.newSchedule.Night
                                                          .checked,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newSchedule.Night.checked[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "b-modal",
        {
          key: _vm.modalKey2,
          attrs: {
            "can-cancel": ["escape", "x"],
            active: _vm.isEditingSchedule,
            scroll: "keep",
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isEditingSchedule = $event
            },
          },
        },
        [
          _vm.isEditingSchedule
            ? _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submitEdit.apply(null, arguments)
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-card",
                      staticStyle: {
                        "min-width": "50vw",
                        width: "fit-content",
                        "min-height": "50vh",
                        height: "fit-content",
                      },
                    },
                    [
                      _c("header", { staticClass: "modal-card-head" }, [
                        _c("p", { staticClass: "modal-card-title" }, [
                          _vm._v(" Edit Schedule "),
                          _vm.selectedPlant
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "1rem",
                                    "text-overflow": "elipsis",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.selectedPlant.name))]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                      _c(
                        "section",
                        { staticClass: "modal-card-body" },
                        [
                          _c(
                            "b-field",
                            { attrs: { grouped: "" } },
                            [
                              _c("b-field", { attrs: { label: "Date" } }, [
                                _vm._v(
                                  " " + _vm._s(_vm.editableSchedule.date) + " "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._l(_vm.editableEmployees, function (employee) {
                            return _c(
                              "div",
                              {
                                key: employee.id + "new",
                                staticStyle: { width: "10%" },
                              },
                              [
                                _c(
                                  "b-field",
                                  { attrs: { grouped: "" } },
                                  [
                                    _c(
                                      "b-field",
                                      {
                                        staticStyle: { "margin-top": "0.7em" },
                                      },
                                      [
                                        _c("multiselect", {
                                          attrs: {
                                            options: ["AM", "PM", "Night"],
                                            multiple: true,
                                            searchable: false,
                                            "show-labels": false,
                                            "close-on-select": false,
                                          },
                                          model: {
                                            value:
                                              _vm.editableSchedule.shift[
                                                employee.id
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.editableSchedule.shift,
                                                employee.id,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "editableSchedule.shift[employee.id]",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-field",
                                      {
                                        staticStyle: {
                                          "align-content": "center",
                                          "margin-top": "0.5em",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              employee.name +
                                                (employee.surname &&
                                                employee.surname.length > 0
                                                  ? " " + employee.surname
                                                  : "")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _vm.editableSchedule.shift[employee.id]
                                      .length <= 0
                                      ? _c(
                                          "b-field",
                                          { attrs: { grouped: "" } },
                                          [
                                            _c(
                                              "b-checkbox",
                                              {
                                                model: {
                                                  value:
                                                    _vm.editableSchedule
                                                      .deleted[employee.id],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.editableSchedule
                                                        .deleted,
                                                      employee.id,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editableSchedule.deleted[employee.id]",
                                                },
                                              },
                                              [_vm._v(" No Shift? ")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.editableSchedule.shift[
                                      employee.id
                                    ].includes("AM")
                                      ? _c(
                                          "b-field",
                                          { attrs: { grouped: "" } },
                                          [
                                            _c(
                                              "b-field",
                                              { attrs: { label: "ᅟ" } },
                                              [
                                                _c(
                                                  "b-field",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                      width: "5ch",
                                                    },
                                                  },
                                                  [_vm._v(" AM ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Manual" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.AM
                                                        .washing[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.AM
                                                          .washing,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.AM.washing[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Machine" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.AM
                                                        .machine[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.AM
                                                          .machine,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.AM.machine[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Repair" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.AM
                                                        .repair[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.AM
                                                          .repair,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.AM.repair[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Doors" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.AM
                                                        .doors[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.AM
                                                          .doors,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.AM.doors[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Forklift" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.AM
                                                        .forklift[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.AM
                                                          .forklift,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.AM.forklift[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Special" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.AM
                                                        .special[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.AM
                                                          .special,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.AM.special[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Comment" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: {
                                                    width: "10em",
                                                  },
                                                  attrs: { type: "text" },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.AM
                                                        .comment[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.AM
                                                          .comment,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.AM.comment[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Absence" } },
                                              [
                                                _c(
                                                  "b-select",
                                                  {
                                                    staticStyle: {
                                                      width: "6em",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editableSchedule.AM
                                                          .absence[employee.id],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.editableSchedule
                                                            .AM.absence,
                                                          employee.id,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editableSchedule.AM.absence[employee.id]",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "no" },
                                                      },
                                                      [_vm._v(" No ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AL" },
                                                      },
                                                      [_vm._v(" Annual Leave ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "ML" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Medical Leave "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AB" },
                                                      },
                                                      [_vm._v(" Absence ")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              {
                                                staticStyle: {
                                                  "align-content": "center",
                                                },
                                                attrs: { label: "ᅟ" },
                                              },
                                              [
                                                _c("b-checkbox", {
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.AM
                                                        .checked[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.AM
                                                          .checked,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.AM.checked[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.editableSchedule.shift[
                                      employee.id
                                    ].includes("PM")
                                      ? _c(
                                          "b-field",
                                          { attrs: { grouped: "" } },
                                          [
                                            _c(
                                              "b-field",
                                              { attrs: { label: "ᅟ" } },
                                              [
                                                _c(
                                                  "b-field",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                      width: "5ch",
                                                    },
                                                  },
                                                  [_vm._v(" PM ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Manual" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.PM
                                                        .washing[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.PM
                                                          .washing,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.PM.washing[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Machine" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.PM
                                                        .machine[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.PM
                                                          .machine,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.PM.machine[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Repair" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.PM
                                                        .repair[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.PM
                                                          .repair,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.PM.repair[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Doors" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.PM
                                                        .doors[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.PM
                                                          .doors,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.PM.doors[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Forklift" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.PM
                                                        .forklift[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.PM
                                                          .forklift,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.PM.forklift[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Special" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.PM
                                                        .special[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.PM
                                                          .special,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.PM.special[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Comment" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: {
                                                    width: "10em",
                                                  },
                                                  attrs: { type: "text" },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.PM
                                                        .comment[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.PM
                                                          .comment,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.PM.comment[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Absence" } },
                                              [
                                                _c(
                                                  "b-select",
                                                  {
                                                    staticStyle: {
                                                      width: "6em",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editableSchedule.PM
                                                          .absence[employee.id],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.editableSchedule
                                                            .PM.absence,
                                                          employee.id,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editableSchedule.PM.absence[employee.id]",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "no" },
                                                      },
                                                      [_vm._v(" No ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AL" },
                                                      },
                                                      [_vm._v(" Annual Leave ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "ML" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Medical Leave "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AB" },
                                                      },
                                                      [_vm._v(" Absence ")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              {
                                                staticStyle: {
                                                  "align-content": "center",
                                                },
                                                attrs: { label: "ᅟ" },
                                              },
                                              [
                                                _c("b-checkbox", {
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.PM
                                                        .checked[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule.PM
                                                          .checked,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.PM.checked[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.editableSchedule.shift[
                                      employee.id
                                    ].includes("Night")
                                      ? _c(
                                          "b-field",
                                          { attrs: { grouped: "" } },
                                          [
                                            _c(
                                              "b-field",
                                              { attrs: { label: "ᅟ" } },
                                              [
                                                _c(
                                                  "b-field",
                                                  {
                                                    staticStyle: {
                                                      "font-weight": "bold",
                                                      width: "5ch",
                                                    },
                                                  },
                                                  [_vm._v(" Night ")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Manual" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.Night
                                                        .washing[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule
                                                          .Night.washing,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.Night.washing[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Machine" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.Night
                                                        .machine[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule
                                                          .Night.machine,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.Night.machine[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Repair" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.Night
                                                        .repair[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule
                                                          .Night.repair,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.Night.repair[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Doors" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.Night
                                                        .doors[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule
                                                          .Night.doors,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.Night.doors[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Forklift" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.Night
                                                        .forklift[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule
                                                          .Night.forklift,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.Night.forklift[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Special" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: { width: "5em" },
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    max: "12",
                                                    step: "0.01",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.Night
                                                        .special[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule
                                                          .Night.special,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.Night.special[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Comment" } },
                                              [
                                                _c("b-input", {
                                                  staticStyle: {
                                                    width: "10em",
                                                  },
                                                  attrs: { type: "text" },
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.Night
                                                        .comment[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule
                                                          .Night.comment,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.Night.comment[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              { attrs: { label: "Absence" } },
                                              [
                                                _c(
                                                  "b-select",
                                                  {
                                                    staticStyle: {
                                                      width: "6em",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.editableSchedule
                                                          .Night.absence[
                                                          employee.id
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.editableSchedule
                                                            .Night.absence,
                                                          employee.id,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "editableSchedule.Night.absence[employee.id]",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "no" },
                                                      },
                                                      [_vm._v(" No ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AL" },
                                                      },
                                                      [_vm._v(" Annual Leave ")]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "ML" },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Medical Leave "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: { value: "AB" },
                                                      },
                                                      [_vm._v(" Absence ")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-field",
                                              {
                                                staticStyle: {
                                                  "align-content": "center",
                                                },
                                                attrs: { label: "ᅟ" },
                                              },
                                              [
                                                _c("b-checkbox", {
                                                  model: {
                                                    value:
                                                      _vm.editableSchedule.Night
                                                        .checked[employee.id],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editableSchedule
                                                          .Night.checked,
                                                        employee.id,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editableSchedule.Night.checked[employee.id]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                      _c("footer", { staticClass: "modal-card-foot" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info is-fullwidth",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }